export default __webpack_public_path__ + "static/media/field.f2116b33.jpg";